import { dateTimeWithFormat, formatScheduleEndDate } from '@sequencehq/utils'
import { phaseDateFormat } from 'modules/Cube/cube.constants'

/**
 * How a schedule's span is written wherever someone has to recognise one at a glance: the
 * amend-a-schedule select, and the pill naming the schedule an amendment quote was built from.
 * Shared so the two can't drift apart. `formatScheduleEndDate` handles the open-ended and
 * milestone cases, so an empty end date is fine to pass through.
 */
export const formatScheduleDateRange = (schedule: {
  startDate: string
  endDate?: string | null
}) =>
  `${dateTimeWithFormat(schedule.startDate, phaseDateFormat)} - ${formatScheduleEndDate(
    schedule.endDate ?? ''
  )}`
